import { render, staticRenderFns } from "./buy-rule.vue?vue&type=template&id=4a8a0c09&lang=pug&"
import script from "./buy-rule.vue?vue&type=script&lang=js&"
export * from "./buy-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports